module.exports = __webpack_public_path__ + "static/media/missing.66cceeaa.gif";